import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { SentryService } from './app/services/sentry-service.service';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

SentryService.initSentry()

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
